module.exports = __webpack_public_path__ + "img/51.170ca2d0.png";